import React, {useState} from 'react';
import {Accordion, DropdownIndicator, customStyles} from '../../../components';
import Select from 'react-select';
import {copyBlue} from '../../../assets/images/images';

const INTEGRATION = [
  {label: 'Web SDK', value: 'web_sdk'},
  {label: 'Flow link', value: 'flow_link'},
  {label: 'Mobile', value: 'mobile'},
];

function Integration() {
  const [selectedIntegration, setSelectedIntegration] = useState(null);

  return (
    <Accordion title="Integration">
      <p className="text-xs text-body leading-[18px]">
        Select your preferred integration.
      </p>

      <div className="relative mt-4">
        <Select
          defaultValue={selectedIntegration}
          value={selectedIntegration}
          options={INTEGRATION}
          onChange={int => {
            setSelectedIntegration(int);
            // handleSelectedIntegration(int, int);
            // setWidgetScreen({
            //   page: int.value,
            // });
          }}
          placeholder="Select an integration type"
          components={{DropdownIndicator}}
          classNamePrefix="react-select"
          styles={customStyles}
          menuPlacement="top"
        />
      </div>

      {selectedIntegration?.value === 'flow_link' ? (
        <div className="mt-4">
          <p className="text-sm text-body">Copy link</p>
          <div className="relative mt-1">
            <button className="absolute flex items-center gap-2 p-2 -translate-y-1/2 border rounded top-2/4 right-4 border-brandBlue">
              <img src={copyBlue} alt="" width={14} height={14} />
              <span className="text-xs font-medium text-brandBlue">Copy</span>
            </button>
            <input
              type="text"
              id="confidence_level"
              className="text-sm text-grey"
              value={'Save widget to generate link'}
              readOnly
            />
          </div>
        </div>
      ) : null}
    </Accordion>
  );
}

export default Integration;
